export class VouchersUtils {

  public static isValidCode(code: string): { valid: boolean, code: string } {
    code = code.replaceAll('ß', '-');

    return {
      valid: /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(code) || code.length === 8,
      code
    };
  }
}
